// ZA: We don't use the react-datepicker for now, because it is not accessible enough.
// But I will keep the old code as well.
/*
import * as React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { defaultDateFormat } from '../../constants';
import { isStringNullOrWhiteSpace, isDateStringNullOrEmpty, isDateValid } from '../../tools/validator';
import { toDate } from '../../tools/toolkit';
import ModalDialogWarning from './ModalDialogWarning';
import { PleaseEnterValidDate } from '../../messages/businessMessages';
//import { EditableInputButtons } from './EditableInputButtons';
//import $ from 'jquery';

let tabPressed = false;
let warningMessage = PleaseEnterValidDate;

export class SVMDatePicker extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            className: `${this.getDefaultClassName()}`,
            editableButtonsVisibility: false,
            isCancelAction: false,
            // We get all date as dateString from SVMDatePicker, but React Datepicker needs them as Date.
            prevDate: isDateStringNullOrEmpty(this.props.value) ? undefined : new Date(this.props.value),
            startDate: isDateStringNullOrEmpty(this.props.value) ? undefined : new Date(this.props.value),
            minDate: isDateStringNullOrEmpty(this.props.minDate) ? undefined : new Date(this.props.minDate)
        };

        this.handleFocus = this.handleFocus.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        //this.handleCancelClick = this.handleCancelClick.bind(this);
    }

    getDefaultClassName() {
        let className = 'svmDatePicker';

        if (this.props.className) {
            className += ` ${this.props.className}`;
        }

        return className;
    }

    getDateFormat() {
        if (this.props.dateFormat) {
            return this.props.dateFormat;
        }

        return defaultDateFormat;
    }

    getRequired() {
        if (this.props.required && (this.props.required === 'true' || this.props.required === true)) {
            return true;
        }

        return false;
    }


    handleFocus() {
        let minDate = undefined;

        if (this.props.minDateInputName && document.getElementsByName(this.props.minDateInputName)[0]) {
            minDate = toDate(document.getElementsByName(this.props.minDateInputName)[0].value);
        }

        if (this.props.isEditable && this.props.canEdit) {
            this.setState({
                editableButtonsVisibility: true,
                isCancelAction: false,
                minDate: minDate
            });
        }
        else {
            this.setState({
                minDate: minDate
            });
        }
    }

    handleKeyDown = event => {

        tabPressed = false;

        if (event.key === 'Tab') {
            tabPressed = true;
            this.onBlurAction(event);
        }
    }

    handleChange = date => {
        this.setState({
            startDate: date
        });
    }

    handleBlur(event) {
        if (tabPressed) {
            tabPressed = false;
        }
        else {
            this.onBlurAction(event);
        }
    }

    onBlurAction(event) {
        if (this.state.isCancelAction) {
            this.datepicker.setState({ inputValue: this.state.prevDate });
        }
        else {
            let startDate = this.state.startDate;
            let value = event.target.value;

            const date = toDate(event.target.value);

            if (!isDateValid(date) || (this.state.minDate && date < this.state.minDate)) {
                this.datepicker.setState({ inputValue: null });

                this.showWarningMessage(value);

                startDate = undefined;
                value = null;

                this.setState({
                    startDate: startDate
                });
            }

            this.callSaveClick(value, startDate);
        }
    }

    showWarningMessage(value) {
        warningMessage = PleaseEnterValidDate;

        let messages = [];

        if (!isStringNullOrWhiteSpace(value)) {
            const date = toDate(value);

            if (!isDateValid(date)) {

                if (this.props.dateWarningMessage) {
                    warningMessage = `${this.props.dateWarningMessage} is invalid. ${PleaseEnterValidDate}`;
                }

                //$("#invalidDateWarningMD_" + this.props.id).modal();
                messages.push({ controlId: this.props.id, message: warningMessage });
                this.props.onValidationError(messages);
                return false;
            }

            if (this.state.minDate && date < this.state.minDate) {

                if (this.props.minDateWarningMessage) {
                    warningMessage = `${this.props.minDateWarningMessage} ${PleaseEnterValidDate}`
                }

                //$("#invalidDateWarningMD_" + this.props.id).modal();
                messages.push({ controlId: this.props.id, message: warningMessage });
                this.props.onValidationError(messages);
                return false;
            }
        }

        this.props.onValidationError(messages);
        return true;
    }

    callSaveClick(value, startDate) {
        if (this.props.isEditable && this.props.canEdit) {
            if (this.props.onSaveClick) {
                if ((value === '' && this.state.prevDate !== undefined) || (isDateValid(toDate(value))) && this.hasValueChanged()) {
                    this.props.onSaveClick((startDate === null || startDate === undefined) ? null : startDate.toDateString());
                }
            }

            this.setState({
                editableButtonsVisibility: false,
                isCancelAction: false,
                prevDate: startDate,
            });
        }
    }

    hasValueChanged() {
        return ((this.state.prevDate === undefined || this.state.prevDate === null) && (this.state.startDate !== undefined || this.state.startDate !== null)) || (this.state.prevDate.toDateString() !== this.state.startDate.toDateString());
    }

    componentDidMount() {
        this.setAttributesForAccessibility();
    }

    componentDidUpdate() {
        this.setAttributesForAccessibility();
    }

    setAttributesForAccessibility() {
        const control = document.getElementById(this.props.id);

        if (this.props.ariaLabel) {
            control.setAttribute('aria-label', this.props.ariaLabel);
        }

        if (this.props.ariaRequired) {
            control.setAttribute('aria-required', this.props.ariaRequired);
        }
    }

    renderEditableControls() {
        // AP-4833, it has been invisibled for bbc. We can use this feature for other broadcaster in future
        //if (this.props.isEditable && this.props.canEdit) {
        //    return (
        //        <EditableInputButtons onSaveClick={this.handleSaveClick} onCancelClick={this.handleCancelClick} visible={this.state.editableButtonsVisibility} left='75' />
        //    );
        //}

        return '';
    }

    handleCancelClick(event) {
        // AP-4833, it has been invisibled for bbc. We can use this feature for other broadcaster in future
        //if (this.props.isEditable && this.props.canEdit) {
        //    this.setState({
        //        startDate: this.state.prevDate,
        //        isCancelAction: true,
        //        editableButtonsVisibility: false
        //    });
        //}
    }

    render() {
        return (
            <div>
                <DatePicker
                    className={this.state.className}
                    id={this.props.id}
                    name={this.props.name}
                    ref={datepicker => { this.datepicker = datepicker; }}
                    todayButton="Today"
                    placeholderText={defaultDateFormat}
                    minDate={this.state.minDate}
                    showDisabledMonthNavigation
                    disabled={!this.props.canEdit}
                    showYearDropdown
                    yearDropdownItemNumber={15}
                    showMonthDropdown
                    dropdownMode="select"
                    autoComplete='off'
                    selected={this.state.startDate}
                    dateFormat={this.getDateFormat()}
                    required={this.getRequired()}
                    onFocus={this.handleFocus}
                    onKeyDown={(e) => { this.handleKeyDown(e); }}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                />
                {this.renderEditableControls()}
                <ModalDialogWarning id={'invalidDateWarningMD_' + this.props.id} message={warningMessage} className='w-75' />
            </div>
        );
    }


    // PUBLIC FUNCTIONS

    addClassName(value) {
        this.setState({
            className: `${this.getDefaultClassName()} ${value}`
        });
    }

    removeClassName(value) {
        if (this.state.startDate) {
            this.datepicker.input.classList.remove(value);

            this.setState({
                className: `${this.datepicker.input.className}`
            });
        }
    }

    getDateString() {
        if (this.state.startDate) {
            return this.state.startDate.toDateString();
        }
    }
}
*/

import * as React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { defaultDateFormat } from '../../constants';
import { isStringNullOrWhiteSpace, isDateValid } from '../../tools/validator';
import { toDate, toFormattedShortDate } from '../../tools/toolkit';
import { PleaseEnterValidDate } from '../../messages/businessMessages';

let warningMessage = PleaseEnterValidDate;

let oldValue = '';
let oldSelectionStart = 0;
let oldSelectionEnd = 0;


export class SVMDatePicker extends React.Component {

    constructor(props) {
        super(props);

        // Value saved as dateString and load as string (short date).
        this.state = {
            className: `${this.getDefaultClassName()}`,
            editableButtonsVisibility: false,
            isCancelAction: false,
            prevDate: isStringNullOrWhiteSpace(this.props.value) ? '' : toFormattedShortDate(this.props.value),
            startDate: isStringNullOrWhiteSpace(this.props.value) ? '' : toFormattedShortDate(this.props.value),
            minDate: isStringNullOrWhiteSpace(this.props.minDate) ? '' : toFormattedShortDate(this.props.minDate),
            changed: false
        };

        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    getDefaultClassName() {
        if (this.props.className) {
            return `svmDatePicker ${this.props.className}`;
        }

        return 'svmDatePicker';
    }

    getDateFormat() {
        if (this.props.dateFormat) {
            return this.props.dateFormat;
        }

        return defaultDateFormat;
    }


    handleGivenValue(event) {
        const filter = (value) => { return /^[0-9/]{0,10}$/.test(value); };

        if (filter(event.target.value)) {
            oldValue = event.target.value;
            oldSelectionStart = event.target.selectionStart;
            oldSelectionEnd = event.target.selectionEnd;
        } else if (oldValue) {
            event.target.value = oldValue;
            event.target.setSelectionRange(oldSelectionStart, oldSelectionEnd);
        } else {
            event.target.value = '';
        }

        if (this.state.startDate !== event.target.value) {
            this.setState({
                startDate: event.target.value,
                changed: true
            });
        }
    }

    handleFocus() {
        let minDate = undefined;

        if (this.props.minDateInputName && document.getElementsByName(this.props.minDateInputName)[0]) {
            minDate = document.getElementsByName(this.props.minDateInputName)[0].value;
        }

        if (this.props.isEditable && this.props.canEdit) {
            this.setState({
                editableButtonsVisibility: true,
                isCancelAction: false,
                minDate: minDate
            });
        }
        else {
            this.setState({
                minDate: minDate
            });
        }
    }

    handleBlur(event) {

        if (this.state.isCancelAction) {
            this.setState({ startDate: this.state.prevDate });
        }
        else {
            if (this.state.changed) {
                this.setState({
                    changed: false
                });

                if (this.showWarningMessage()) {
                    this.callSaveClick();
                }
            }
        }
    }

    showWarningMessage() {
        warningMessage = PleaseEnterValidDate;

        let messages = [];
        this.removeClassName('mandatoryBg');

        if (!isStringNullOrWhiteSpace(this.state.startDate)) {
            const parts = this.state.startDate.split('/');

            if (parts.length !== 3 || parts[0].length !== 2 || parts[1].length !== 2 || parts[2].length !== 4) {
                if (this.props.dateWarningMessage) { warningMessage = `${this.props.dateWarningMessage} is invalid. ${PleaseEnterValidDate}`; }
                this.addClassName('mandatoryBg');
                messages.push({ controlId: this.props.id, message: warningMessage });
                this.props.onValidationError(messages);
                return false;
            }

            const date = toDate(this.state.startDate);

            if (!isDateValid(date)) {
                if (this.props.dateWarningMessage) { warningMessage = `${this.props.dateWarningMessage} is invalid. ${PleaseEnterValidDate}`; }
                this.addClassName('mandatoryBg');
                messages.push({ controlId: this.props.id, message: warningMessage });
                this.props.onValidationError(messages);
                return false;
            }

            if (this.state.minDate !== '' && date < toDate(this.state.minDate)) {
                if (this.props.minDateWarningMessage) { warningMessage = `${this.props.minDateWarningMessage} ${PleaseEnterValidDate}`; }
                this.addClassName('mandatoryBg');
                messages.push({ controlId: this.props.id, message: warningMessage });
                this.props.onValidationError(messages);
                return false;
            }
        }

        this.props.onValidationError(messages);
        return true;
    }

    callSaveClick() {
        const date = toDate(this.state.startDate);

        if (this.props.isEditable && this.props.canEdit) {
            if (this.props.onSaveClick) {
                if (this.hasValueChanged()) {
                    if (isStringNullOrWhiteSpace(this.state.startDate)) {
                        this.props.onSaveClick(undefined);
                    }
                    else if (isDateValid(date)) {
                        this.props.onSaveClick(date.toDateString());
                    }
                }
            }

            this.setState({
                editableButtonsVisibility: false,
                isCancelAction: false,
                prevDate: this.state.startDate
            });
        }
    }

    hasValueChanged() {
        return ((this.state.prevDate === '' || this.state.prevDate === null) && (this.state.startDate !== '' || this.state.startDate !== null)) || (this.state.prevDate !== this.state.startDate);
    }

    render() {
        return (
            <div>
                <input
                    className={this.state.className}
                    id={this.props.id}
                    name={this.props.name}
                    placeholder={this.getDateFormat()}
                    disabled={!this.props.canEdit}
                    autoComplete='off'
                    aria-label={`${this.props.ariaLabel}. The expected format is ${this.getDateFormat()}`}
                    aria-required={this.props.ariaRequired}
                    value={this.state.startDate}
                    onInput={e => this.handleGivenValue(e)}
                    onKeyDown={e => this.handleGivenValue(e)}
                    onKeyUp={e => this.handleGivenValue(e)}
                    onMouseDown={e => this.handleGivenValue(e)}
                    onMouseUp={e => this.handleGivenValue(e)}
                    onSelect={e => this.handleGivenValue(e)}
                    onContextMenu={e => this.handleGivenValue(e)}
                    onDrop={e => this.handleGivenValue(e)}
                    onFocus={e => this.handleFocus(e)}
                    onBlur={e => this.handleBlur(e)}
                />
            </div>
        );
    }

    // PUBLIC FUNCTIONS

    addClassName(value) {
        this.setState({
            className: `${this.getDefaultClassName()} ${value}`
        });
    }

    removeClassName(value) {
        this.setState({
            className: `${this.getDefaultClassName()}`
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/Controls/SVMDatePicker.js